learnDashboardApp.factory('V3MyStudyStatsResource', ['$resource', ($resource) ->
  $resource "", {},
    query:
      method: 'GET'
      isArray: false
      url: APIRoutes.v3_my_study_stats_path()
])
